var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-modal',{ref:"teamInboxTutorialComponent",staticClass:"pl-2",attrs:{"has-activator-button":"","should-show-in-first-visit":true,"cookie-name":"ring-group-team-inbox","title":"Explore Aloware Team Inboxes","video-url":"https://www.loom.com/embed/57c6edbbdfdb4c7aa3ca3f31a4c463fc?sid=65c7a1b1-89dc-4bb2-a682-4e7f7947c5a4"}})
}
var staticRenderFns = []

export { render, staticRenderFns }